<template>
    <div class="coupon-list">
        <!-- 判断是否使用新版本样式组件 -->
        <template v-if="useNewVersion">
            <coupon-item-v2
                v-for="(v, k) in coupons"
                v-intersection
                :data-log="formatTjData(v, k)"
                :key="k + '-v2'"
                :useMethod="useMethod"
                :checked="couponItemCheckStatus(v)"
                :coupon="v"
                :disable="disable"
                :expandDefault="expandDefault"
                :showReceiveIcon="showReceiveIcon"
                :showGotoUseBtn="showGotoUseBtn"
                :customGotoUse="customGotoUse"
                :showExpiresSoon="showExpiresSoon"
                :receiveCacheTime="receiveCacheTime"
                :isShowCheck="!forceUseReCashCard(v)"
                :tabLabel="tabLabel"
                @click="clickItem(k, v)"
                @onReceive="onReceive(arguments[0], v, k)"
                @gotoUse="gotoUse(v, k)"
                @showloginwall="showLoginWall"
                @beforeClick="coupon => handleBeforeClick(coupon, k)"
                :business="business"
            ></coupon-item-v2>
        </template>
        <template v-else>
            <coupon-item
                v-for="(v, k) in coupons"
                v-intersection
                :data-log="formatTjData(v, k)"
                :key="k"
                :useMethod="useMethod"
                :checked="couponItemCheckStatus(v)"
                :coupon="v"
                :disable="disable"
                :expandDefault="expandDefault"
                :showReceiveIcon="showReceiveIcon"
                :showGotoUseBtn="showGotoUseBtn"
                :customGotoUse="customGotoUse"
                :showExpiresSoon="showExpiresSoon"
                :receiveCacheTime="receiveCacheTime"
                :isShowCheck="!forceUseReCashCard(v)"
                :tabLabel="tabLabel"
                @click="clickItem(k, v)"
                @onReceive="onReceive(arguments[0], v, k)"
                @gotoUse="gotoUse(v, k)"
                @showloginwall="showLoginWall"
                @beforeClick="coupon => handleBeforeClick(coupon, k)"
                :business="business"
            ></coupon-item>
        </template>
    </div>
</template>

<script>
import CouponItem from 'root/common/components/coupon/couponItem.vue';
import CouponItemV2 from 'root/common/components/coupon/couponItemV2.vue';
import { receiveExpirationTimeRange } from './utils/index';
import tqCommonTracker from 'root/common/util/tqCommonTracker';
import { getGioFloorVar, gioEvariableTrack } from 'root/common/gio/index';

export default {
    name: 'coupon-list',
    components: {
        CouponItem,
        CouponItemV2,
    },
    data() {
        return {
            checkId: null,
            msg: '',
            btnText: '',
            firstClick: true,
            noSelect: false,
            isRecashCard: false,
        };
    },
    props: {
        autoCheckCoupon: {
            type: Boolean,
            default: false,
        },
        showReceiveIcon: {
            default: true,
            type: Boolean,
        },
        coupons: {
            type: Array,
            default: () => [],
        },
        useMethod: {
            default: 'click', // 可选值 1.click: 点击事件  2.check: 选择    ...
            type: String,
        },
        defaultCheckId: {
            type: [String, Number],
        },
        disable: {
            default: false,
            type: Boolean,
        },
        // 是否隐藏去使用按钮
        showGotoUseBtn: {
            default: true,
            type: Boolean,
        },
        // 是否默认展开详情
        expandDefault: {
            default: false,
            type: Boolean,
        },
        customGotoUse: {
            default: false,
            type: Boolean,
        },
        // 是否展示快过期的tag
        showExpiresSoon: {
            type: Boolean,
        },
        receiveCacheTime: {
            type: Number,
            default: receiveExpirationTimeRange,
        },
        tabLabel: {
            default: '',
            type: String,
        },
        tjObjId: {
            type: String,
            default: '',
        },
        tjObjType: {
            type: String,
            default: '',
        },
        business: String,
        useNewVersion: {
            default: false,
            type: Boolean,
        },
    },
    created() {
        this.checkId = this.defaultCheckId;
    },
    watch: {
        defaultCheckId(v) {
            if (!v) this.checkId = v;
        },
    },
    methods: {
        //假券曝光
        formatTjData(coupon, index) {
            const checkAvailable = this.business == 'recharge' && this.tjObjId && coupon && coupon?.isFake; //占位券判断逻辑
            let data = {};
            let gioAdData = {
                gioAction: 'adPositionView',
                gioActionData: getGioFloorVar({
                    module_var: '优惠信息',
                    floor_var: this.disable ? '优惠券列表（不可用）' : '优惠券列表（可用）',
                    position_var: index + 1,
                    positionName_var: coupon?.couponName,
                }),
            };
            if (checkAvailable) {
                if (window.bigTj) {
                    data = {
                        ...gioAdData,
                        obj_id: this.tjObjId,
                        obj_type: this.tjObjType,
                        item_id: coupon?.couponId,
                        item_name: coupon?.couponName,
                        item_sort: index + 1,
                        location: '',
                        location_id: '',
                        location_sort: 1,
                        page_source_type: 'recharge_detail',
                        sa_login_id: window.localStorage.getItem('member_id'),
                        sa_card_id: window.localStorage.getItem('card_id') || '',
                    };
                }
            } else {
                data = gioAdData;
            }
            return JSON.stringify(data);
        },
        couponItemCheckStatus(coupon) {
            //假券不可选中
            if (this.business === 'recharge' && coupon.isFake) {
                return false;
            } else {
                return this.autoCheckCoupon
                    ? coupon.receiveId === this.defaultCheckId
                    : this.checkId || !this.firstClick
                    ? coupon.receiveId === this.checkId
                    : coupon.receiveId === this.defaultCheckId;
            }
        },
        /**
         * gio流量位点击
         * @param {Object} { module_var, floor_var, position_var, positionName_var }
         * module_var 模块
         * floor_var 流量位
         * position_var 坑位
         * positionName_var 坑位名称
         */
        handleAdPositionClick({ module_var, floor_var, position_var, positionName_var }) {
            gioEvariableTrack(
                'adPositionClick',
                getGioFloorVar({
                    module_var,
                    floor_var,
                    position_var,
                    positionName_var,
                })
            );
        },
        clickItem(index, item) {
            if (this.business === 'recharge' && item.isFake) {
                return false;
            }
            if (this.useMethod == 'check') {
                // 判断是否第一次点击, 第一次this.checkId为null
                if (this.firstClick) {
                    // 判断选中的是否跟默认的优惠券一样
                    if (this.defaultCheckId != item.receiveId) {
                        this.$emit('change', index, item);
                        this.checkId = item.receiveId;
                    } else {
                        this.$emit('cancel', index, item);
                        this.checkId = null;
                    }
                    this.firstClick = false;
                } else {
                    // 判断id是否不一样
                    if (this.checkId != item.receiveId) {
                        this.$emit('change', index, item);
                        this.checkId = item.receiveId;
                    } else {
                        this.$emit('cancel', index, item);
                        this.checkId = null;
                    }
                }
            }
            this.$emit('click', index, item);
        },
        // 选择优惠券（金卡假券）
        chooseCouponTrack(item, index) {
            if (this.business == 'recharge') {
                tqCommonTracker.track('click', {
                    obj_id: 'yhq_xz_button',
                    obj_type: 'cz_qrdd_page',
                    item_id: item?.couponId,
                    item_name: item?.couponName,
                    item_sort: index + 1,
                    location: '',
                    location_id: '',
                    location_sort: index + 1,
                    page_source_type: 'recharge_detail',
                    sa_login_id: window.localStorage.getItem('member_id'),
                    sa_card_id: window.localStorage.getItem('card_id') || '',
                });
            }
        },
        getCheckedResult() {
            return this.checkId;
        },
        toIndex() {
            window.ZZCFL.Utils.goToIndex();
        },
        onReceive(res, item, index) {
            this.$emit('onreceive', res, item, index);
        },
        gotoUse(item, index) {
            this.$emit('gotouse', item, index);
        },
        showLoginWall() {
            this.$emit('showloginwall');
        },
        handleBeforeClick(coupon, index) {
            if (this.business === 'recharge') {
                if (coupon && coupon?.isFake) {
                    //金卡假券逻辑
                    this.chooseCouponTrack(coupon, index);
                }
                this.handleAdPositionClick({
                    module_var: '优惠信息',
                    floor_var: this.disable ? '优惠券列表（不可用）' : '优惠券列表（可用）',
                    position_var: index + 1,
                    positionName_var: coupon?.couponName || '',
                });
            }
            this.isRecashCard = coupon.couponType == 'RE_CASH_CARD';
        },

        forceUseReCashCard(coupon) {
            const enableCoupon = this.coupons.find(i => i.enable);
            const enableCouponList = this.coupons.filter(i => i.enable);
            const reCashCardEnableCouponList = enableCouponList.filter(i => i.couponType == 'RE_CASH_CARD');
            const defaultCouponList = enableCouponList.filter(i => i.couponType != 'RE_CASH_CARD');
            if (this.business === 'recharge') {
                if (coupon?.isFake == true) {
                    return false;
                }
            }
            if (this.business === 'movie') {
                return false;
            }
            // 优惠券可用列表仅有单张返现卡 强制使用
            if (
                enableCoupon &&
                reCashCardEnableCouponList.length == 1 &&
                coupon.couponType == 'RE_CASH_CARD' &&
                !defaultCouponList.length
            ) {
                return true;
            }

            // 如果同时有优惠券和返现卡 且最优是优惠券， 反选优惠券，强制使用返现卡
            if (
                reCashCardEnableCouponList.length == 1 &&
                coupon.couponType == 'RE_CASH_CARD' &&
                !this.checkId &&
                !this.isRecashCard
            ) {
                return true;
            }

            return false;
        },
    },
};
</script>

<style lang="scss"></style>
